import { Link2 } from "lucide-react";
import type { ModuleSpec } from "../types";

export const integrationsSpec: ModuleSpec = {
  id: "integrations",
  icon: Link2,
  i18n: {
    namespace: "modules",
    titleKey: "integrations.title",
    descriptionKey: "integrations.description",
  },
  nav: {
    path: "/integrations",
    group: "connect",
    order: 20,
  },
  permission: {
    action: "read",
    subject: "integration",
  },
  meta: {
    status: "active",
    description: "Manage CRM, CDP sync, webhooks, and API integrations",
  },
};
